import { Config } from "./config.interface";

export const defaultConfig: Config = {
  // default configuration for dev env, can be overridden (per property) using environment variable CLIENT_CONFIGURATION_JSON (JSON formatted value)
  version: "1.0",
  gaId: null,
  gtmId: null,
  adLogoutAddressWithoutRedirectUri:
    "https://login.microsoftonline.com/e843756e-a005-4dad-af39-2aac0e2b937e/oauth2/logout?post_logout_redirect_uri=",
  /* Note for academy and extranet urls: These point to test envs that are backed by iLOQ Partner Portal _TEST_ AD. So the user must exist in both dev AD and test AD to be able to visit these addresses via dev env */
  academyUrl: "https://iloq-test.spce.com/identity/external/login/aadiloq?domain_hint=",
  academyEnabledCountryList: ["US", "CA"],
  extranetUrlForProducts:
    "https://s10test.iloq.com/PartnerExtranet/secure/products?showNavigation=false",
  extranetUrlForOrders:
    "https://s10test.iloq.com/PartnerExtranet/secure/orders?showNavigation=false",
  extranetUrlForShoppingCart:
    "https://s10test.iloq.com/PartnerExtranet/secure/cart?showNavigation=false",
  extranetUrlForLicenses:
    "https://s10test.iloq.com/PartnerExtranet/secure/licenses?showNavigation=false",
  /* Auto-login works only if dev env is run on https://localhost:44310 and against test-AD. Also, one needs to be able to disable auto-login by not providing this value in envs config, so the default config should not contain anything. */
  extranetUrlForLogin: null, // 'https://s10test.iloq.com/PartnerExtranet/api/Auth/LoginAzureUser',
  extranetUrlForLogout: "https://s10test.iloq.com/PartnerExtranet/partnerlogout",
  saabIframeBaseUrl: "http://localhost:3003",
  /* Note: brandstore has only one env that is (normally) working against production AD */
  brandstoreUrl: "https://brandstore.iloq.com/?ssoauth=login",
  /* ProForma not required countries list */
  proFormaNotRequiredCountryListBySubsidiary: {
    ILOQ_OY: [
      "AT", // Austria
      "BE", // Belgium
      "BG", // Bulgaria
      "HR", // Croatia
      "CY", // Cyprus
      "CZ", // Czechia
      "DK", // Denmark
      "EE", // Estonia
      "FI", // Finland
      "AX", // Åland islands
      "FR", // France
      "DE", // Germany
      "GR", // Greece
      "HU", // Hungary
      "IE", // Ireland
      "IT", // Italy
      "LV", // Latvia
      "LT", // Lithuania
      "LU", // Luxembourg
      "MT", // Malta
      "NL", // Netherlands
      "PL", // Poland
      "PT", // Portugal
      "RO", // Romania
      "SK", // Slovakia
      "SI", // Slovenia
      "ES", // Spain
      "SE", // Sweden
    ],
    ILOQ_USA_INC: ["US"], // United States
  },
  materialDamMappingList: { Finland: "FI", International: "OTHER" },
  materialDamWhiteListedCategories: [
    "Brochures",
    "Brand images",
    "Logos",
    "Images",
    "munkkiniemi",
    "Mobile solutions, iLOQ 50 images",
    "iLOQ Brand guidelines",
    "Product Videos",
    "Videos",
    "Price lists, license forms",
    "Residential videos",
    "iLOQ North America videos",
    "Mobile solutions, iLOQ 50 images",
  ],
  materialDamMainCategories: [
    "Brochures",
    "iLOQ Brand guidelines",
    "Brand images",
    "Logos",
    "Videos",
    "Price lists, license forms",
  ],
  materialDamPriceListCategory: "Price lists, license forms",
  bundledProductCategories: {},
  orderMaxProductQuantity: "10000",
  customerReturnMaxSize: "500",
  productSearchPageSize: "30",
  solutionArticleSearchPageSize: "30",
  supportTicketSearchPageSize: 4,
  maintenanceReturnPolicyUrl: "/support/solutions/categories/80000456124/80000682431/80000960674",
  salesReturnPolicyUrl: "/support/solutions/categories/80000456123/80000682446/80000960669",
  partnerProgramKnowledgeBaseURL: "/support/solutions/categories/80000456126/80000682458",
  partnerProgramBrandStoreURL: "https://godev.innoflame.fi/gogive/iloq/?ssoauth=login",
  partnerProgramDashboardCTAURL:
    "/support/solutions/categories/80000456126/80000682458/80000960651",
  partnerProgramNPSReportsCTAURL:
    "/support/solutions/categories/80000456126/80000682458/80000960656",
  partnerProgramPartnerPointsCTAURL:
    "/support/solutions/categories/80000456126/80000682458/80000960652",
  restrictedProductFamilies: [
    // TODO: Enable S50 products once all iLOQ branches are ready for the change
    // "A50",
    // "AC50",
    // "AD50",
    // "AF50",
    // "AG50",
    // "AH50",
    // "AK50",
    // "AP50",
    // "B50S",
    // "C50S",
    // "D50S",
    // "F50S",
    // "G50S",
    // "H50S",
    // "K50S",
    // "P50S",
    // "S50S",
    "ZWARRANTY",
  ],
  campaignReturnAllowedCountryList: ["FI", "SE"],
  appInsightConnectionString: "",
  mapboxAccessToken:
    "pk.eyJ1IjoicG9wb3RldXMiLCJhIjoiY2xsbm02Nzc0MDBncTNxbW5ibWU3OGtkdSJ9.kvWqwDCOprY08levd5xVgA",
  disableReturnsForInc: false,
  subscriptionViewAllowedCountryList: [],
  features: undefined,
};
